import React, { Component } from 'react'
import { DropdownToggle } from 'reactstrap';
import S3 from 'react-aws-s3';
import { Link } from "react-router-dom";


import {Col, Card, CardBody, CustomInput, Dropdown, Modal, ModalHeader, ModalBody, Input, Button, Label, FormGroup, Alert} from "reactstrap"
import FilePreviewerThumbnail from 'react-file-previewer';
import { victimVideoUrl } from '../../helpers/url';



export default class VictimVideoAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            success: false,
            successMessage: "",
            menu : false,
            modal_center: false,

            tempVideoType: 1,
			tempVideoId: 0,
			tempDescription: '',
			tempTranscript: '',
			tempVideoLocation: '',
			tempPublish: 0
        }
        this.tog_center = this.tog_center.bind(this);
    }

    tog_center() {
        this.setState(prevState => ({
          modal_center: !prevState.modal_center
        }));
    }

    fileSubmitToS3 = async (event) => {
		const config = {
			bucketName: process.env.REACT_APP_BUCKET_NAME,
			region: process.env.REACT_APP_REGION,
			accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
			secretAccessKey: process.env.REACT_APP_SECRET_KEY_ID,
		};
		const ReactS3Client = new S3(config);
		await ReactS3Client.uploadFile(event.target.files[0], 'testimony/' + this.props.victimId + '/video/' + event.target.files[0].name)
			.then(data => {
				if (data && data.location) {
						this.setState({
							tempVideoLocation: data.location,
						});
				}
			})
			.catch(err => {
				this.setState({
					error: true,
					errorMsg: err.message,
				});
			});
	};

    submit = () => {
        const session = JSON.parse(sessionStorage.getItem('authUser'));
		const userId = session.payload.sub;
		const accessToken = session.jwtToken;
		fetch(victimVideoUrl, {
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify({
				type: parseInt(this.state.tempVideoType),
				description: this.state.tempDescription,
				transcript: this.state.tempTranscript,
				s3location: this.state.tempVideoLocation,
				victimId: this.props.victimId,
				videoId: this.state.tempVideoId,
				publish: this.state.tempPublish,
				userId: userId
            })
        }).then(res=>res.json())
        .then(data => {
            console.log(data);
            this.setState({
                success: true,
                successMessage: "Submitted! Go back to Testimony Manager and come back again."
            })
        })
        
    }

    tempStateHandling = (event) => {
        let targetId = event.target.id;
		let targetValue = event.target.value;
		let targetType = event.target.type;
        console.log(targetId, targetValue, targetType)
		if (targetType === 'text' || targetType === "textarea") {
            this.setState({
                [targetId]: targetValue,
			});
        }
        else if (targetType === 'number' || targetType === 'select-one') {
			if (targetValue === isNaN) {
				targetValue = 0;
			}
			this.setState({
				[targetId]: parseInt(targetValue),
			});
        }
        else {
			this.setState({
				[event.target.id]: event.target.value,
			});
		}
    }


    render() {
        return (
            <React.Fragment>
                            <Dropdown className="float-right" isOpen={this.state.menu} toggle={() => this.setState({menu : !this.state.menu})}>
                                <DropdownToggle tag="i" className="darrow-none card-drop" aria-expanded="false">
                                    <Link>
                                        <Button onClick={this.tog_center} color="primary" block type="button" className="waves-effect waves-light mt-2 mr-1">
                                            <i className="mdi mdi-book-plus-multiple-outline"></i> Add Video 
                                        </Button>
                                    </Link>

                                    <Modal size="lg" isOpen={this.state.modal_center} toggle={this.tog_center} centered={true} >
                                        <ModalHeader toggle={() => this.setState({ modal_center: false })}> Video - Add </ModalHeader>
                                        <ModalBody>
															<Card>
																<CardBody>
                                                                <div className="mt-5 text-center">
                                                                    <Alert color="success" isOpen={this.state.success} toggle={() => {this.setState({success:!this.state.success, successMessage: ""})}}>
                                                                        {this.state.successMessage}
                                                                    </Alert>
                                                                </div>
																	<FormGroup row>
																		<Label className="col-md-2 col-form-label">
																			Video Type
																		</Label>
																		<Col md={8}>
																			<select
																				className="custom-select"
																				id="tempVideoType"
																				onChange={event => this.tempStateHandling(event)}
																				value={this.state.tempVideoType}>
																				<option value="1">UTJD Testimony</option>
																				<option value="2">Private</option>
																				<option value="3">Chinese Sources</option>
																				<option value="4">Media</option>
																				<option value="5">Other</option>
																			</select>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																			Upload Video
																		</Label>
																		<Col md={8}>
																			<div className="custom-file mb-2">
																				<CustomInput
																					type="file"
																					className="custom-file-input"
																					id="tempVideoFileHolder"
																					onChange={event => {
																						this.fileSubmitToS3(event);
																					}}
																				/>
																				<Label className="custom-file-label" htmlFor="tempVideoFileHolder">
																					Choose file
																				</Label>
																			</div>
																		</Col>
																		<Col md={8}>
																			<div className="testimony-file-preview text-center">
																				{this.state.tempImageLocation !== '' ? (
																					<div>Uploaded</div>
																				) : (
																					//<Label htmlFor="example-text-input" className="col-md-2 col-form-label">{this.state.tempDocumentLocation.substr(this.state.tempDocumentLocation.length - 3)} Ready</Label>

																					''
																				)}
																			</div>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																			Description
																		</Label>
																		<Col md={8}>
																			<Input
																				className="form-control"
																				type="text"
																				placeholder="Please provide a description for the video"
																				id="tempDescription"
																				onChange={event => this.tempStateHandling(event)}
																				value={this.state.tempDescription}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																			Transcript
																		</Label>
																		<Col md={8}>
																			<Input
																				className="form-control"
																				type="text"
																				placeholder="Please provide a video transcript if available"
																				id="tempTranscript"
																				onChange={event => this.tempStateHandling(event)}
																				value={this.state.tempTranscript}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label className="col-md-2 col-form-label">
																			Can be publicly shared/published
																		</Label>
																		<Col md={8}>
																			<select
																				className="custom-select"
																				id="tempPublish"
																				onChange={event => this.tempStateHandling(event)}
																				value={this.state.tempPublish}>
																				<option value="0">Not defined</option>
																				<option value="1">Yes</option>
																				<option value="2">No</option>
																			</select>
																		</Col>
																	</FormGroup>
																	<FormGroup className="text-center">
																		<Button
																			color="primary"
																			type="button"
																			className="waves-effect waves-light me-1"
																			onClick={() => { this.submit() }}>
																			Submit <i className="ri-arrow-right-line align-middle ms-2"></i>
																		</Button>
																	</FormGroup>
                                                                </CardBody>
                                                            </Card>
                                        </ModalBody>
                                    </Modal>
                                </DropdownToggle>
                            </Dropdown>
            </React.Fragment>
        )
    }
}
